import { Routes, Route, Navigate } from "react-router-dom";

// Layout
import DashboardLayout from "./layout/DashboardLayout";

// Rutas protegidas
import ProtectedRoute from "./routes/protectedRoute";
import RoleRoute from "./routes/roleRoute";

// Pages
import Dashboard from "./pages/Dashboard";
import Calendario from "./pages/Calendario/index";
import DistributionReport from "./pages/DistributionReport";
import Clientes from "./pages/Clientes/index";
import Analisis from "./pages/Analisis/index";
import Documentos from "./pages/Documentos";
import Verificacion from "./pages/Verificacion";
import Tecnicos from "./pages/Tecnicos";
import Evaluacion from "./pages/Evaluacion";
import Inventario from "./pages/Inventario";
import Login from "./pages/Login/index";
import Servicios from "./pages/Servicios/index";
import Dev from "./pages/Dev";
import Rendimiento from "./pages/Rendimiento";
import Programacion from "./pages/Programacion";
import Sucursal from "./pages/Sucursal";
import Certificados from "./pages/Certificados/index";
import Seguridad from "./pages/Seguridad";
import AgendaTecnico from "./pages/AgendaTecnico";
import VerificarCertificado from "./pages/VerificarCertificado";
// import Reportes from "./pages/Reportes";
// import Cloud from "./pages/Cloud";

// Componentes de auditoría
import ActivityTracker from "./components/ActivityTracker";
import Mantenimiento from "./pages/Mantenimiento";
import { ACCESS } from "./utils/rolePermissions";
import { useAuth } from "./context/authContext";

function HomeGate() {
  const { role } = useAuth();
  if (role === "technician") return <Navigate to="/agenda" replace />;
  return <Dashboard />;
}

export default function App() {
  return (
    <>
      {/* Rastreador de actividad - Se ejecuta en toda la aplicación */}
      <ActivityTracker />
      
      <Routes>
        {/* Login y página de verificación de muestra (sin layout) */}
        <Route path="/login" element={<Login />} />
        <Route path="/verificar/muestra" element={<VerificarCertificado />} />

        {/* Rutas protegidas con layout */}
        <Route element={<ProtectedRoute />}>
          <Route element={<DashboardLayout />}>

          {/* Admin L3 */}
          <Route element={<RoleRoute allowedRoles={ACCESS.ADMIN_ONLY} />}>
            <Route path="/analisis" element={<Analisis />} />
            <Route path="/rendimiento" element={<Rendimiento />} />
            <Route path="/dev" element={<Dev />} />
            <Route path="/programacion" element={<Programacion />} />
            <Route path="/seguridad" element={<Seguridad />} />

            {/* Rutas vacias */}
            <Route path="/verificacion" element={<Verificacion />} />
            <Route path="/documentos" element={<Documentos />} />
          </Route>


          {/* Inventario */}
          <Route element={<RoleRoute allowedRoles={ACCESS.INVENTARIO} />}>
            <Route path="/inventario" element={<Inventario />} />
          </Route>

          {/* Recursos Humanos */}
          <Route element={<RoleRoute allowedRoles={ACCESS.RH_MODULE} />}>
            <Route path="/tecnicos" element={<Tecnicos />} />
          </Route>

          {/* Evaluación mensual de técnicos */}
          <Route element={<RoleRoute allowedRoles={ACCESS.EVALUACION} />}>
            <Route path="/evaluacion" element={<Evaluacion />} />
            <Route path="/calidad" element={<Navigate to="/evaluacion" replace />} />
          </Route>

          {/* Administración L1 */}
          <Route element={<RoleRoute allowedRoles={ACCESS.OPERATIONS} />}>
            <Route path="/calendario" element={<Calendario />} />
            <Route path="/servicios" element={<Servicios />} />
            <Route path="/rutas" element={<Mantenimiento />} />
            <Route path="/cloud" element={<Mantenimiento />} />
            <Route path="/clientes" element={<Clientes />} />
            {/* <Route path="/reportes" element={<Reportes />} /> */}
            <Route path="/distribucion" element={<DistributionReport />} />
            <Route path="/certificados" element={<Certificados />} />
            <Route path="/sucursales/:id" element={<Sucursal />} />
          </Route>

          {/* Agenda del técnico en campo */}
          <Route element={<RoleRoute allowedRoles={ACCESS.AGENDA} />}>
            <Route path="/agenda" element={<AgendaTecnico />} />
          </Route>

          {/* Rutas comunes */}
          <Route element={<RoleRoute allowedRoles={[...ACCESS.DASHBOARD, ...ACCESS.AGENDA]} />}>
            <Route path="/" element={<HomeGate />} />
          </Route>

          {/* Rutas vacias */}
          <Route path="*" element={<HomeGate />} />
          </Route>
        </Route>
      </Routes>
    </>
  );
}